import React from "react";

const strengths = [
  {
    title: "Diverse fleet",
    text: "Luxury, sport, family, SUV, sedan, and daily-use cars for different trips across Dubai.",
  },
  {
    title: "Flexible rentals",
    text: "Daily and monthly options designed for visitors, residents, families, and business travel.",
  },
  {
    title: "Clear support",
    text: "A responsive team ready to help you choose the right car and arrange your rental smoothly.",
  },
];

function About() {
  return (
    <div className="aboutContainer">
      <section className="aboutHero">
        <div className="aboutHeroCopy">
          <p>About Oh My Car</p>
          <h1>Car rental built for Dubai roads.</h1>
          <span>
            We help residents and visitors choose the right car for the way
            they want to move through Dubai.
          </span>
        </div>
        <div className="aboutHeroImage" aria-hidden="true"></div>
      </section>

      <section className="aboutStrengths" aria-label="Why choose Oh My Car">
        {strengths.map((item) => (
          <article key={item.title}>
            <h2>{item.title}</h2>
            <p>{item.text}</p>
          </article>
        ))}
      </section>

      <section className="aboutContent">
        <div>
          <h2>Our journey</h2>
          <p>
            Since 2022, Oh My Car has focused on reliable car rental service in
            Dubai, combining clear pricing, helpful support, and a practical
            selection of cars for different needs.
          </p>
          <p>
            Whether you need a comfortable family SUV, a daily-use sedan, a
            sport car, or a luxury vehicle for a special occasion, our goal is
            to make the rental experience simple from the first message.
          </p>
        </div>
        <div>
          <h2>Our mission</h2>
          <p>
            We keep the process direct: choose a car, select your rental period,
            and contact us on WhatsApp for fast confirmation. Every detail is
            handled with customer comfort and vehicle quality in mind.
          </p>
          <p>
            Thank you for choosing Oh My Car. We look forward to helping you
            discover Dubai with the right car.
          </p>
        </div>
      </section>
    </div>
  );
}

export default About;
